var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('h6',{staticClass:"mb-2"},[_vm._v("Devices")]),_c('v-combobox',{attrs:{"items":_vm.devices,"outlined":"","dense":"","multiple":""},model:{value:(_vm.selected_devices),callback:function ($$v) {_vm.selected_devices=$$v},expression:"selected_devices"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }